import { render, staticRenderFns } from "./DisableCouponLoader.vue?vue&type=template&id=4cef9089"
import script from "./DisableCouponLoader.vue?vue&type=script&lang=ts"
export * from "./DisableCouponLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports